import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Firing } from "../types";

const useFirebaseFirings = () => {
  const uid = useFakedUID();
  return useFirebaseData<FirebaseRecord<Firing>>(uid ? `/userdata/${uid}/firings` : null);
};

export default useFirebaseFirings;
